export default __webpack_public_path__ + "static/media/028-oars.a8db87ee.png";